export default __webpack_public_path__ + "maps-examples-heatmap-example-1200-c88c82b3ea45cab33eeec6c4eb7a659c.png";